import React from 'react'
import { IconContext } from 'react-icons'
import { FaTrashAlt } from 'react-icons/fa'

const DeleteIcon = () => {
  return (
    <IconContext.Provider value={{size: "2em", color: "red" }}>
      <div>
        <FaTrashAlt />
      </div>
    </IconContext.Provider>
  )
}

export default DeleteIcon
